import React from "react";
import { ProducerStatsLoaderTemplate } from "themes/application/producer/components";

function ProducerStatsLoader(props) {
    return <ProducerStatsLoaderTemplate {...props} />;
}

export default ProducerStatsLoader;
